import React, { useState, useEffect } from "react";
import WorkerBottomBar from "../Components/WorkerBottomBar.js";
import Device from "../Components/devices/Device.js";

const { useAxios } = require("#api");

const DevicesDashboard = () => {
  const [deviceinfo, setDeviceinfo] = useState([]);
  const [alldevicestat, setAlldevicestat] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [elements , setElements] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const axiosInstance = useAxios();

  const fetchData = async () => {
    try {
      
      const deviceinfo = await axiosInstance.post(
        "/deviceinfo", {
          token: localStorage.getItem('token')
        }
      );
      const alldevicestat = await axiosInstance.post(
        "/alldevicestat", {
          token: localStorage.getItem('token')
        }
      );

      setDeviceinfo(deviceinfo.data);
      setAlldevicestat(alldevicestat.data);

      if(deviceinfo?.data){
        setElements(deviceinfo.data);
      }

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!isDataFetched) {
      fetchData();
      setIsDataFetched(true);
    }
  }, [isDataFetched]);

  const Skeleton = () => {
    return (
      <div className="flex w-full mx-auto overflow-hidden bg-white rounded-lg shadow-lg animate-pulse">
        <div className="w-full p-4 md:p-4">
          <h1 className="w-40 h-2 bg-gray-200 rounded-lg "></h1>

          <p className="w-48 h-2 mt-4 bg-gray-200 rounded-lg "></p>

          <div className="flex mt-4 item-center gap-x-2">
            <p className="w-5 h-2 bg-gray-200 rounded-lg "></p>
            <p className="w-5 h-2 bg-gray-200 rounded-lg "></p>
            <p className="w-5 h-2 bg-gray-200 rounded-lg "></p>
            <p className="w-5 h-2 bg-gray-200 rounded-lg "></p>
            <p className="w-5 h-2 bg-gray-200 rounded-lg "></p>
          </div>

          <div className="flex justify-between mt-6 item-center">
            <h1 className="w-10 h-2 bg-gray-200 rounded-lg "></h1>

            <div className="h-4 bg-gray-200 rounded-lg w-28 "></div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="dashboard pt-8 pb-24 rtl">
        <div className="container px-4">
          <div className="row">
            <h2>تجهیزات شما</h2>
           <div className="row mt-4 grid grid-cols-1 gap-4 justify-items-center">
              {isLoading ? (
                <>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </>
              ) : (
                elements.map((element, index) => (
                  element.Enable && <Device key={index} element={element} Data={alldevicestat[0]?.Data} UID={deviceinfo[0]?.UID} />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <WorkerBottomBar />
    </>
  );
};

export default DevicesDashboard;
